import React, { useState } from 'react';

const Logo = () => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <img src="/favicon_nowatt.png" alt="Nowatt" style={{ width: 40, height: 40, objectFit: 'contain', mixBlendMode: 'screen' }} />
    <span style={{ fontFamily: "'Lexend', sans-serif", fontSize: '1.2rem', fontWeight: 700 }}>
      <span style={{ color: '#C8F135' }}>No</span><span style={{ color: '#EEF2FF' }}>watt</span>
    </span>
  </div>
);

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontFamily: "'Lexend', sans-serif", fontSize: '1.1rem', fontWeight: 700, color: '#C8F135', marginBottom: 12 }}>{title}</h2>
    <div style={{ color: 'rgba(238,242,255,0.7)', fontSize: '0.88rem', lineHeight: 1.8 }}>{children}</div>
  </div>
);

const CGU = () => (
  <div>
    <h1 style={{ fontFamily: "'Lexend', sans-serif", fontSize: '1.8rem', fontWeight: 700, marginBottom: 8 }}>Conditions Generales d Utilisation</h1>
    <p style={{ color: 'rgba(238,242,255,0.4)', fontSize: '0.82rem', marginBottom: 40 }}>Derniere mise a jour : avril 2026</p>

    <Section title="1. Presentation du service">
      <p>Nowatt est un service en ligne de comparaison et de recommandation d offres d electricite en France, edite par Nowatt (ci-apres "la Societe"), dont le siege social est en cours d immatriculation en France.</p>
      <p style={{ marginTop: 8 }}>Contact : <a href="mailto:contact@nowatt.app" style={{ color: '#C8F135' }}>contact@nowatt.app</a></p>
    </Section>

    <Section title="2. Acceptation des conditions">
      <p>L acces et l utilisation du service Nowatt impliquent l acceptation pleine et entiere des presentes conditions generales d utilisation. Si vous n acceptez pas ces conditions, vous devez cesser d utiliser le service.</p>
    </Section>

    <Section title="3. Description du service">
      <p>Nowatt propose les services suivants :</p>
      <ul style={{ paddingLeft: 20, marginTop: 8 }}>
        <li>Comparaison des offres d electricite des fournisseurs presents sur le marche français</li>
        <li>Recommandation personnalisee de la meilleure offre selon votre consommation</li>
        <li>Suivi et historique de vos comparaisons</li>
        <li>Alertes en cas d evolution favorable des offres du marche</li>
      </ul>
      <p style={{ marginTop: 8 }}>Nowatt est un service de comparaison et de recommandation. Il n agit pas en qualite de fournisseur d electricite et ne procede pas au changement de fournisseur en votre nom sans votre accord explicite.</p>
    </Section>

    <Section title="4. Compte utilisateur">
      <p>L acces au service necessite la creation d un compte. Vous vous engagez a fournir des informations exactes et a maintenir la confidentialite de vos identifiants. Vous etes responsable de toute activite effectuee depuis votre compte.</p>
    </Section>

    <Section title="5. Abonnement et tarification">
      <p>Le service est accessible sur abonnement mensuel au tarif de 5,99€ TTC par mois. L abonnement est sans engagement et resiliable a tout moment depuis votre espace personnel. La resiliation prend effet a la fin de la periode en cours.</p>
      <p style={{ marginTop: 8 }}>Le paiement est securise et traite par Stripe. Nowatt ne conserve aucune donnee bancaire.</p>
    </Section>

    <Section title="6. Donnees et exactitude des informations">
      <p>Les tarifs et offres presentes sur Nowatt sont fournis a titre indicatif et mis a jour regulierement. Nowatt ne garantit pas l exactitude en temps reel des informations affichees. Les offres definitives sont celles communiquees directement par les fournisseurs.</p>
    </Section>

    <Section title="7. Propriete intellectuelle">
      <p>L ensemble des elements constituant le service Nowatt (logo, interface, textes, algorithmes) est la propriete exclusive de Nowatt et est protege par les lois en vigueur. Toute reproduction ou utilisation non autorisee est interdite.</p>
    </Section>

    <Section title="8. Limitation de responsabilite">
      <p>Nowatt s efforce d assurer la disponibilite et la fiabilite du service mais ne peut etre tenu responsable des interruptions techniques, des erreurs de tarification des fournisseurs, ou des pertes indirectes resultant de l utilisation du service.</p>
    </Section>

    <Section title="9. Modification des CGU">
      <p>Nowatt se reserve le droit de modifier les presentes CGU a tout moment. Les utilisateurs seront informes par email de toute modification substantielle. La poursuite de l utilisation du service apres notification vaut acceptation des nouvelles conditions.</p>
    </Section>

    <Section title="10. Droit applicable">
      <p>Les presentes CGU sont soumises au droit français. Tout litige sera soumis a la juridiction des tribunaux français competents.</p>
    </Section>
  </div>
);

const Privacy = () => (
  <div>
    <h1 style={{ fontFamily: "'Lexend', sans-serif", fontSize: '1.8rem', fontWeight: 700, marginBottom: 8 }}>Politique de Confidentialite</h1>
    <p style={{ color: 'rgba(238,242,255,0.4)', fontSize: '0.82rem', marginBottom: 40 }}>Derniere mise a jour : avril 2026 — conforme au RGPD</p>

    <Section title="1. Responsable du traitement">
      <p>Le responsable du traitement des donnees personnelles est Nowatt, dont le siege social est en cours d immatriculation en France.</p>
      <p style={{ marginTop: 8 }}>Contact DPO : <a href="mailto:contact@nowatt.app" style={{ color: '#C8F135' }}>contact@nowatt.app</a></p>
    </Section>

    <Section title="2. Donnees collectees">
      <p>Nowatt collecte uniquement les donnees necessaires au fonctionnement du service :</p>
      <ul style={{ paddingLeft: 20, marginTop: 8 }}>
        <li>Adresse email (identification et communication)</li>
        <li>Nom complet (personnalisation du service)</li>
        <li>Donnees de consommation electrique saisies (calcul des recommandations)</li>
        <li>Historique des comparaisons effectuees</li>
        <li>Donnees de navigation (logs techniques)</li>
      </ul>
    </Section>

    <Section title="3. Finalites du traitement">
      <p>Vos donnees sont utilisees exclusivement pour :</p>
      <ul style={{ paddingLeft: 20, marginTop: 8 }}>
        <li>La gestion de votre compte et l authentification</li>
        <li>La fourniture du service de comparaison et de recommandation</li>
        <li>L envoi de notifications liees au service (nouvelles offres, alertes)</li>
        <li>La facturation et la gestion de votre abonnement</li>
        <li>L amelioration du service</li>
      </ul>
    </Section>

    <Section title="4. Base legale">
      <p>Le traitement de vos donnees est fonde sur :</p>
      <ul style={{ paddingLeft: 20, marginTop: 8 }}>
        <li>L execution du contrat de service (CGU acceptees)</li>
        <li>Le consentement pour les communications marketing</li>
        <li>L interet legitime pour l amelioration du service</li>
      </ul>
    </Section>

    <Section title="5. Duree de conservation">
      <p>Vos donnees sont conservees pendant toute la duree de votre abonnement, et supprimees dans un delai de 30 jours apres la resiliation de votre compte, sauf obligation legale contraire.</p>
    </Section>

    <Section title="6. Partage des donnees">
      <p>Nowatt ne vend ni ne loue vos donnees personnelles. Vos donnees peuvent etre partagees avec :</p>
      <ul style={{ paddingLeft: 20, marginTop: 8 }}>
        <li>Supabase (hebergement et authentification) — serveurs en Europe</li>
        <li>Stripe (paiement securise) — aucune donnee bancaire stockee par Nowatt</li>
        <li>Resend (envoi d emails transactionnels)</li>
      </ul>
    </Section>

    <Section title="7. Vos droits RGPD">
      <p>Conformement au RGPD, vous disposez des droits suivants :</p>
      <ul style={{ paddingLeft: 20, marginTop: 8 }}>
        <li>Droit d acces a vos donnees</li>
        <li>Droit de rectification</li>
        <li>Droit a l effacement (droit a l oubli)</li>
        <li>Droit a la portabilite</li>
        <li>Droit d opposition au traitement</li>
        <li>Droit de limitation du traitement</li>
      </ul>
      <p style={{ marginTop: 8 }}>Pour exercer ces droits, contactez-nous a : <a href="mailto:contact@nowatt.app" style={{ color: '#C8F135' }}>contact@nowatt.app</a></p>
      <p style={{ marginTop: 8 }}>Vous avez egalement le droit d introduire une reclamation aupres de la CNIL (www.cnil.fr).</p>
    </Section>

    <Section title="8. Cookies">
      <p>Nowatt utilise uniquement des cookies techniques indispensables au fonctionnement du service (authentification, session). Aucun cookie publicitaire ou de tracking n est utilise.</p>
    </Section>

    <Section title="9. Securite">
      <p>Nowatt met en oeuvre des mesures techniques et organisationnelles appropriees pour proteger vos donnees : chiffrement des communications (HTTPS), authentification securisee via Supabase, acces restreint aux donnees.</p>
    </Section>

    <Section title="10. Contact">
      <p>Pour toute question relative a la protection de vos donnees : <a href="mailto:contact@nowatt.app" style={{ color: '#C8F135' }}>contact@nowatt.app</a></p>
    </Section>
  </div>
);

export default function Legal({ onBack, initialTab = 'cgu' }) {
  const [tab, setTab] = useState(initialTab);

  return (
    <div style={{ background: '#06080C', color: '#EEF2FF', fontFamily: "'Plus Jakarta Sans', sans-serif", minHeight: '100vh' }}>
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 48px', borderBottom: '1px solid rgba(238,242,255,0.06)' }}>
        <Logo />
        <button onClick={onBack} style={{ background: 'transparent', color: 'rgba(238,242,255,0.5)', border: '1px solid rgba(238,242,255,0.15)', borderRadius: 8, padding: '8px 16px', cursor: 'pointer', fontSize: '0.85rem', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          ← Retour
        </button>
      </nav>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: '48px 24px' }}>
        <div style={{ display: 'flex', gap: 12, marginBottom: 40 }}>
          {[['cgu', 'CGU'], ['privacy', 'Confidentialite']].map(([key, label]) => (
            <button key={key} onClick={() => setTab(key)} style={{
              background: tab === key ? 'rgba(200,241,53,0.12)' : 'transparent',
              color: tab === key ? '#C8F135' : 'rgba(238,242,255,0.4)',
              border: tab === key ? '1px solid rgba(200,241,53,0.3)' : '1px solid rgba(238,242,255,0.1)',
              borderRadius: 8, padding: '8px 20px', cursor: 'pointer', fontSize: '0.88rem', fontFamily: "'Plus Jakarta Sans', sans-serif"
            }}>{label}</button>
          ))}
        </div>
        {tab === 'cgu' ? <CGU /> : <Privacy />}
      </div>
    </div>
  );
}
